"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mobileDesktop(criteria, services) {
    var value = criteria[0].values[0];
    switch (value) {
        case 'mobile':
            return services.browserEnvironment.userAgent.toUpperCase().includes('MOBILE');
        case 'desktop':
            return !services.browserEnvironment.userAgent.toUpperCase().includes('MOBILE');
        default:
            return false;
    }
}
exports.default = mobileDesktop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9iaWxlRGVza3RvcC5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzcmMvbGliL3NlcnZpY2VzL3RhcmdldHMvbW9iaWxlRGVza3RvcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBLFNBQXdCLGFBQWEsQ0FBRSxRQUFrQyxFQUFFLFFBQXNCO0lBQzdGLElBQU0sS0FBSyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFFbkMsUUFBUSxLQUFLLEVBQUU7UUFDWCxLQUFLLFFBQVE7WUFDVCxPQUFPLFFBQVEsQ0FBQyxrQkFBa0IsQ0FBQyxTQUFTLENBQUMsV0FBVyxFQUFFLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxDQUFBO1FBQ2pGLEtBQUssU0FBUztZQUNWLE9BQU8sQ0FBQyxRQUFRLENBQUMsa0JBQWtCLENBQUMsU0FBUyxDQUFDLFdBQVcsRUFBRSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQTtRQUNsRjtZQUNJLE9BQU8sS0FBSyxDQUFBO0tBQ25CO0FBQ0wsQ0FBQztBQVhELGdDQVdDIn0=